/**
 * Shared formatting utilities
 */

/**
 * Formats a category enum value into a display string
 * Example: "PASSWORD_RESET" -> "Password Reset"
 */
export function formatCategory(category: string): string {
  return category
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
